module.exports = __webpack_public_path__ + "img/Menu-03.fc6fdf09.png";